// If something begins to play, pause all (other) Mux players
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Stimulus captures bubbling events. 
  // We can use the 'play' event which bubbles (unlike some media events)
  connect() {
    this.element.addEventListener('play', (event) => {
      const justActivatedPlayer = event.target
    
      this.element.querySelectorAll('mux-player').forEach(mux_player => {
        if (mux_player !== justActivatedPlayer) {
          mux_player.pause()
        }
      })
    }, true) // Use capture phase to ensure we catch it
  }
}